import { createFileRoute } from '@tanstack/react-router';

import CaseDetailPanel from '~/app/praetors/cases/CasesV2/CaseDetailPanel';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases/')({
	beforeLoad: () => ({
		getTitle: undefined
	}),
	component: function CasesIndex() {
		return <CaseDetailPanel caseId={undefined} />;
	}
});
